<template>
  <b-modal :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="lg"
    ref="mdlContabilitaTipoDocumento" scrollable @show="onShow" @ok="onOkMdlContabilitaTipoDocumento"
    @cancel="onCancel">
    <b-row>
      <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
        <span class="sa-label-data">Struttura</span>
        <b-form-select v-model="jsonData.codiceStruttura" :options="strutturaOptions" :value="null"
          value-field="codiceStruttura" text-field="denominazione" @input="onInputStrutture">
          <template #first>
            <b-form-select-option :value="null" disabled> - Selezionare Struttura - </b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
        <span class="sa-label-data">Tipo Documento</span>
        <b-form-select v-model="jsonData.tipoDocumento" :options="tipoDocumentoOptions" :value="null"
          value-field="codice" text-field="text">
          <template #first>
            <b-form-select-option :value="null" disabled> - Selezionare Tipo - </b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
        <span class="sa-label-data">Codice</span>
        <b-form-input v-model="jsonData.codiceTipoDocumento" placeholder="Codice Tipo Documento"></b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
        <span class="sa-label-data">Descrizione</span>
        <b-form-input v-model="jsonData.descrizioneTipoDocumento" placeholder="Descrizione"></b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
        <span class="sa-label-data">Numeratore</span>
        <b-form-select v-model="jsonData.codiceNumeratore" :options="numeratoreOptions" :value="null"
          value-field="codice" text-field="descrizione">
          <template #first>
            <b-form-select-option :value="null">No Numeratore</b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
import NumeratoriMixin from "../../numeratori/mixins/NumeratoriMixin";
import toast from "../../../template/layout/utility/sa-toast";
export default {
  inject: ["openShowModalLoading", "closeShowModalLoading"],
  mixins: [UtilityMixin, StruttureMixin, NumeratoriMixin],
  data() {
    return {
      title: "",
      pathResource: "/contabilitadocumentotipo",
      jsonData: { codiceStruttura: null, tipoDocumento: null, codiceTipoDocumento: null, codiceNumeratore: null, descrizioneTipoDocumento: null },
      tipoDocumentoOptions: [
        { text: "EMESSO", codice: "EMESSO" },
        { text: "INTERNO", codice: "INTERNO" },
        { text: "RICEVUTO", codice: "RICEVUTO" },
      ],
      numeratoreOptions: [],
    };
  },
  methods: {
    show(item) {
      let me = this;
      this.struttureLoadData();
      if (item) {
        me.title = "Modifica Tipo Documento";
        this.numeratoriLoadData(me.numeratoriLoadDataSuccess, item.codiceStruttura);
        me.jsonData = item;
      }
      me.$refs.mdlContabilitaTipoDocumento.show();
    },
    hide() {
      let me = this;
      me.$refs.mdlContabilitaTipoDocumento.hide();
    },
    struttureLoadDataSuccess(response) {
      let me = this;
      me.strutturaOptions = response.data.data;
    },
    onOkMdlContabilitaTipoDocumento(bvModalEvent) {
      let me = this;
      bvModalEvent.preventDefault();
      let validation = me.validazione();
      if (!validation.esito) {
        me.generaBtoast(validation);
        return;
      }
      this.openShowModalLoading();
      UtilityMixin.methods.saveResource(me.pathResource, me.jsonData, me.onOkMdlContabilitaTipoDocumentoSuccess, me.onOkMdlContabilitaTipoDocumentoError);
    },
    onOkMdlContabilitaTipoDocumentoSuccess() {
      this.closeShowModalLoading();
      this.hide();
      this.$emit("afterSave");
    },
    onOkMdlContabilitaTipoDocumentoError(error) {
      toast.error(error.response.data.messaggio);
      this.closeShowModalLoading();
    },
    validazione() {
      let esito = true;
      let msg = "";

      if (this.jsonData.tipoDocumento == null || this.jsonData.tipoDocumento.trim() == "") {
        msg += "Tipo Documento non valido non valido ! #";
        esito = false;
      } else {
        if (!"RICEVUTO".includes(this.jsonData.tipoDocumento)) {
          if (this.jsonData.codiceNumeratore == null) {
            msg += `Tipo Documento ${this.jsonData.tipoDocumento} prevede Numeratore ! #`;
            esito = false;
          }
        }
      }

      if (this.jsonData.codiceStruttura == null || this.jsonData.codiceStruttura.trim() == "") {
        msg += "Codice Struttura non valido non valido ! #";
        esito = false;
      }
      if (this.jsonData.codiceTipoDocumento == null || this.jsonData.codiceTipoDocumento.trim() == "") {
        msg += "Codice Tipo Documento non valido non valido ! #";
        esito = false;
      }
      if (this.jsonData.descrizioneTipoDocumento == null || this.jsonData.descrizioneTipoDocumento.trim() == "") {
        msg += "Descrizione Tipo Documento non valido non valido ! #";
        esito = false;
      }

      return { esito: esito, msg: msg };
    },
    generaBtoast(validation) {
      toast.validation(validation)
    },
    onShow() { },
    onInputStrutture(value) {
      this.numeratoriLoadData(this.numeratoriLoadDataSuccess, value);
    },
    numeratoriLoadDataSuccess(response) {
      let me = this;
      me.numeratoreOptions = response.data.data;
    },

    onCancel() {
      console.log("on cancel");
    },
  },
};
</script>

<style></style>
